import * as React from 'react';
import { CommentForm } from './CommentForm';
import type { CommentSubmitPayload } from '@modules/build-hub-comment/types';
import type { Candidate } from '@modules/build-hub-comment/components/CommentAutoCompleter';
import { CREATE_BUILD_HUB_COMMENT_API_ROUTE } from '~/routes/remix-api.app.build-hub-comment-create';
import { useBuildHubData } from '@modules/build-hub/hooks/use-build-hub-data';

export function CommentBox({
    documentId,
    onPosted,
}: {
    documentId?: string;
    onPosted?: (payload: CommentSubmitPayload) => void;
}) {
    const { buildHub } = useBuildHubData();
    const candidates: Candidate[] = [
        ...buildHub.collaborators.map((c) => ({
            type: 'user' as const,
            id: c.id,
            label: c.name,
        })),
    ];

    async function createComment(payload: CommentSubmitPayload) {
        const formData = new FormData();

        // map context.documentId → targetId
        if (payload.context?.documentId) {
            formData.append('targetId', payload.context.documentId);
        }

        // map message
        formData.append('message', payload.message);

        // map entities
        for (const entity of payload.entities) {
            if (entity.type === 'user') {
                formData.append('mentionIds', entity.id);
            }
            if (entity.type === 'file') {
                formData.append('fileIds', entity.id);
            }
        }

        const res = await fetch(CREATE_BUILD_HUB_COMMENT_API_ROUTE, {
            method: 'POST',
            body: formData,
        });

        if (!res.ok) {
            throw new Error('Failed to submit comment');
        }

        const data = await res.json();
        return data;
    }

    return (
        <CommentForm
            documentId={documentId}
            candidates={candidates}
            onSubmit={async (payload) => {
                await createComment(payload);
                onPosted?.(payload);
            }}
        />
    );
}
